import React, { useState } from "react";
import $ from "jquery";
import { Breadcrumb } from "../components";
import "./SignUp.css";

const courses = [
  { value: "", label: "Choose a course" },
  { value: "Search & Visibility Optimization for Modern Businesses", label: "Search & Visibility Optimization for Modern Businesses" },
  { value: "Vibe Coding (No-Code Software Development)", label: "Vibe Coding (No-Code Software Development)" },
  { value: "Python Programming Fundamentals with AI", label: "Python Programming Fundamentals with AI" },
  { value: "Scratch Programming & Logic", label: "Scratch Programming & Logic" },
  { value: "Web Fundamentals", label: "Web Fundamentals" },
  { value: "Full Stack Development", label: "Full Stack Development" },
  { value: "Frontend Development", label: "Frontend Development" },
  { value: "Backend Development", label: "Backend Development" },
  { value: "WordPress - Free", label: "WordPress - Free" },
  { value: "HTML & CSS - Free", label: "HTML & CSS - Free" },
  { value: "Machine Learning Fundamentals", label: "Machine Learning Fundamentals" },
];

const countryCodes = [
  { code: "+254", label: "Kenya (+254)" },
  { code: "+256", label: "Uganda (+256)" },
  { code: "+211", label: "South Sudan (+211)" },
];

const SignUp = () => {
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");

  const validateForm = () => {
    const fullName = $("#fullName").val().toString().trim();
    const email = $("#email").val().toString().trim();
    const phone = $("#phone").val().toString().replace(/\D/g, "");
    const selectedCourse = $("#course").val();

    if (fullName.length < 2) {
      return "Please enter your full name.";
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return "Please enter a valid email address.";
    }

    if (phone.length < 7) {
      return "Please enter a valid phone number.";
    }

    if (!selectedCourse) {
      return "Please choose a course before enrolling.";
    }

    return "";
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const validationMessage = validateForm();

    if (validationMessage) {
      setMessageType("error");
      setMessage(validationMessage);
      return;
    }

    const selectedCourse = $("#course").val();
    const selectedCountryCode = $("#countryCode").val();
    const phoneNumber = $("#phone").val().toString().replace(/\D/g, "");

    const formData = {
      fullName: $("#fullName").val(),
      email: $("#email").val(),
      phone: `${selectedCountryCode} ${phoneNumber}`,
      courses: selectedCourse ? [selectedCourse] : [],
    };

    $.ajax({
      url: "https://formsubmit.co/ajax/clement.alesio1@gmail.com",
      method: "POST",
      data: formData,
      dataType: "json",
      success: function () {
        setMessageType("success");
        setMessage("Thank you! Your registration was successful. We will reach out to you via phone and email to get started in a moment.");
        $("#signupForm")[0].reset();
      },
      error: function () {
        setMessageType("error");
        setMessage("Oops! Something went wrong. Please try again.");
      },
    });
  };

  const whatsappLink = `https://wa.me/254713278747?text=${encodeURIComponent(
    "Hello TimBaktu Academy, I would like to enroll in a course."
  )}`;

  return (
    <>
      <Breadcrumb current="SignUp" />
      <section className="signup-shell">
        <div className="container">
          <div className="signup-window">
            <div className="signup-visual">
              <div className="signup-visual-content">
                <span className="signup-badge">Future-ready learning</span>
                <h1>Start your next chapter with Timbaktu.</h1>
                <p>
                  Join a learning experience built for ambitious students, creators, and career changers ready to grow.
                </p>

                <ul className="signup-benefits">
                  <li>Career-focused training</li>
                  <li>Hands-on digital skills</li>
                  <li>Support from enrollment to completion</li>
                </ul>
              </div>
            </div>

            <div className="signup-panel">
              <div className="signup-card">
                <div className="signup-header">
                  <p className="signup-kicker">Build skills. Create boldly.</p>
                  <h2>Register Here</h2>
                </div>

                {message && <p className={`signup-message ${messageType}`}>{message}</p>}

                <form id="signupForm" onSubmit={handleSubmit} className="signup-form">
                  <div className="field-grid">
                    <div className="form-field full-width">
                      <label htmlFor="fullName">Full Name</label>
                      <input type="text" id="fullName" name="fullName" placeholder="Your full name" required />
                    </div>

                    <div className="form-field full-width">
                      <label htmlFor="email">Email</label>
                      <input type="email" id="email" name="email" placeholder="your@email.com" required />
                    </div>

                    <div className="form-field phone-field">
                      <label htmlFor="phone">Phone Number</label>
                      <div className="phone-input-wrap">
                        <select id="countryCode" name="countryCode" defaultValue="+254" aria-label="Country code">
                          {countryCodes.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.label}
                            </option>
                          ))}
                        </select>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          placeholder="712 345 678"
                          inputMode="numeric"
                          pattern="[0-9]+"
                          minLength="7"
                          maxLength="15"
                          title="Enter a valid phone number"
                          onChange={(event) => {
                            event.target.value = event.target.value.replace(/\D/g, "");
                          }}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-field course-select-field">
                    <label htmlFor="course">Select Course</label>
                    <select id="course" name="course" defaultValue="" required>
                      {courses.map((course) => (
                        <option key={course.value || "placeholder"} value={course.value} disabled={course.value === ""}>
                          {course.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="action-row">
                    <button type="submit" className="theme-btn signup-submit">Enroll now</button>
                    <a className="theme-btn signup-whatsapp" href={whatsappLink} target="_blank" rel="noreferrer">
                      <i className="fab fa-whatsapp" aria-hidden="true"></i>
                      WhatsApp
                    </a>
                  </div>

                  <p className="signup-note">
                    We will reach out to you via phone and email to get started in a moment.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SignUp;
